import React from 'react';
import { Navigate } from "react-router-dom";


const RutaProtegida = ({children}) => {
    const usuarioActivo = sessionStorage.getItem('sesion');
    
    if(usuarioActivo === 'true'){
        return children
    } else {
        return(
            <Navigate to="/login" />
        ) 
    }
}

export default RutaProtegida;